import endpoints from '@/constants/endpoints';
import axiosV2 from '@/data/api/axiosv2';
import {
  OrderDeliveryInfoRequest,
  OrderDeliveryInfoResponse,
} from '../model/orders/detailOrdersDeliveryInfoDto';
import {
  OrderDetailsResponse,
  UpdateDeliverySettingsRequest,
} from '../model/orders/orderDetailsDto';
import { OrderEventsResponse } from '../model/orders/orderEventsDto';

export const getOrderDetails = async (
  orderId: string
): Promise<OrderDetailsResponse> => {
  const endpoint = endpoints.orders.getOrderDetailsV2.replace(
    ':orderId',
    orderId
  );
  return await axiosV2.get<OrderDetailsResponse>(endpoint);
};

export const cancelOrder = async (
  orderId: string,
  reason: string
): Promise<void> => {
  const endpoint = endpoints.orders.setAsCanceled.replace(':orderId', orderId);
  return await axiosV2.post(endpoint, {
    reason: reason,
  });
};

export const acceptOrder = async (orderId: string): Promise<void> => {
  const endpoint = endpoints.orders.setAsAccepted.replace(':orderId', orderId);
  return await axiosV2.post(endpoint);
};

export const setOrderAsDelivered = async (orderId: string): Promise<void> => {
  const endpoint = endpoints.orders.setAsDelivered.replace(':orderId', orderId);
  return await axiosV2.post(endpoint);
};

export const sendOrderNotification = async (orderId: string): Promise<void> => {
  const endpoint = endpoints.orders.sendNotificationToSeller.replace(
    ':orderId',
    orderId
  );
  return await axiosV2.post(endpoint);
};

export const updateDeliverySettings = async (
  orderId: string,
  deliverySettingsUpdate: UpdateDeliverySettingsRequest
): Promise<void> => {
  const endpoint = endpoints.orders.setDeliverySettings.replace(
    ':orderId',
    orderId
  );
  return await axiosV2.post(endpoint, deliverySettingsUpdate);
};

export const getOrderDetailEvents = async (
  orderId: string
): Promise<OrderEventsResponse> => {
  const endpoint = endpoints.orders.getOrderDetailEvents.replace(
    ':orderId',
    orderId
  );
  return await axiosV2.get(endpoint);
};

export const getOrderDeliveryInfo = async (
  orderId: string
): Promise<OrderDeliveryInfoResponse> => {
  const endpoint = endpoints.orders.getOrderDeliveryInfo.replace(
    ':orderId',
    orderId
  );
  return await axiosV2.get<OrderDeliveryInfoResponse>(endpoint);
};

export const updateRemission = async (args: {
  orderId: string;
  file: File;
}): Promise<void> => {
  const endpoint = endpoints.orders.updateRemission.replace(
    ':orderId',
    args.orderId
  );
  await axiosV2.patchForm(endpoint, {
    file: args.file,
  });
};

export const updateOrderDeliveryInfo = async (
  orderId: string,
  deliveryInfo: OrderDeliveryInfoRequest
): Promise<void> => {
  const endpoint = endpoints.orders.setOrderDeliveryInfo.replace(
    ':orderId',
    orderId
  );
  return await axiosV2.post(endpoint, deliveryInfo);
};
